import React, { useEffect } from 'react';
import { report } from 'lib/utils/dataReport';
import { ATTA_REPORT } from 'lib/constants/atta';
import { showIndependentModal } from '../Modal';
import IndependentDialog from '../IndependentDialog';

import './index.scss';

interface LotterySingleResultDialogProps {
  isDebris?: boolean;
  prizeInfo: { [key: string]: any };
  title: string;
  confirmButtonText?: string;
  confirmCallback: () => void;
  closeModal?: () => void;
  isTenDraw?: boolean;
  showTip?: boolean;
  showBottomText?: boolean;
}

const DEBRISTYPE = 12;

const LotterySingleResultDialog = ({
  prizeInfo,
  title,
  confirmButtonText,
  confirmCallback,
  closeModal,
  isTenDraw,
  showTip = true,
  showBottomText = true,
}: LotterySingleResultDialogProps) => {
  const { prizeId, prizeName, prizeType, prizeFragmentInfo, prizePic } = prizeInfo;
  const isDebris = prizeType === DEBRISTYPE;
  useEffect(() => {
    // TODO  gaigaigai
    if (isTenDraw) return;
    const REPORT_KEY = isDebris ? ATTA_REPORT.AWARD_DIALOG.DEBRIS_SHOW : ATTA_REPORT.AWARD_DIALOG.SHOW;
    report(REPORT_KEY, { prizeId, prizeType });
  }, []);

  const bottomText = isTenDraw ? '' : '新用户0.01元订免流享10连抽拿iphone/京东卡/Q币等大奖！';

  return (
    <IndependentDialog
      confirmButtonText={confirmButtonText}
      confirmCallback={() => {
        confirmCallback();
        if (isTenDraw) return;
        const REPORT_KEY = isDebris ? ATTA_REPORT.AWARD_DIALOG.DEBRIS_CLICK : ATTA_REPORT.AWARD_DIALOG.CLICK;
        report(REPORT_KEY, {
          prizeId,
          prizeType,
        });
      }}
      title={title}
      closeModal={closeModal}
      bottomText={showBottomText ? bottomText : ''}
    >
      <div className="lottery-single-result-dialog">
        <div className="lottery-single-result-dialog__imageBox">
          <img src={prizePic} alt="[图片]" />
          <div className="lottery-single-result-dialog__imageBox__name">{prizeName}</div>
          {isDebris && prizeFragmentInfo?.count > 0 ? (
            <div
              className={
                prizeFragmentInfo?.count > 99
                  ? 'lottery-single-result-dialog__imageBox__count lottery-single-result-dialog__imageBox__overCount'
                  : 'lottery-single-result-dialog__imageBox__count'
              }
            >
              {prizeFragmentInfo?.count > 99 ? '99+' : prizeFragmentInfo?.count}
            </div>
          ) : null}
        </div>
        {isDebris && prizeFragmentInfo?.expiryTime ? (
          <div className="lottery-single-result-dialog__expireTime">{`过期时间 ：${prizeFragmentInfo?.expiryTime}`}</div>
        ) : null}
        {isDebris ? <div className="lottery-single-result-dialog__text">{prizeFragmentInfo?.desc}</div> : null}
        {showTip ? (
          <div className="lottery-single-result-dialog__info">
            {isDebris ? (
              '可前往我的奖励页面查看'
            ) : (
              <>
                请前往页面-<i style={{ color: 'yellow' }}>查看我的奖励</i>领奖哦~
              </>
            )}
          </div>
        ) : null}
      </div>
    </IndependentDialog>
  );
};

export const showLotterySingleResultDialog = ({
  title,
  confirmButtonText = '确认',
  prizeInfo = {},
  confirmCallback = () => {},
  closeModal = () => {},
  isTenDraw = false,
  showTip = true,
  showBottomText = true,
}) => showIndependentModal(
    <LotterySingleResultDialog
      title={title}
      confirmButtonText={confirmButtonText}
      prizeInfo={prizeInfo}
      confirmCallback={confirmCallback}
      closeModal={closeModal}
      isTenDraw={isTenDraw}
      showTip={showTip}
      showBottomText={showBottomText}
    />,
    { onBottom: false },
);
